import React, { useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import { CustomInput } from "../../../../components/customInput/CustomInput";
import { BLACK_COLOR, WHITE_COLOR } from "../../../../resources/colorsManager";
import { RiDeleteBinLine } from "react-icons/ri";
import RowButtons from "../../../../../utility/RowButtons";
import { connect, useDispatch } from "react-redux";
import {
  addAccountsAction,
  deleteOneAccountAction,
} from "../../../../../data/redux/action/add_customer/addAccountsAction";
import { useSnackbar } from "notistack";
const AccountContainer = ({
  accountNumber,
  ifscCode,
  title,
  id,
  onClickDelete,
}) => {
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    marginBottom: 15,
    height: 40,
    width: "100%",
    boxShadow: "none",
    minWidth: 280,
    maxWidth: 450,
    marginRight: 20,
    color: "black",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    paddingLeft: 20,
    minWidth: 220,
    maxWidth: 450,
    marginRight: 20,
    fontSize: 12,
  };
  return (
    <div
      style={{
        width: "100%",
        padding: "7px 7px",
        border: "1px solid dodgerblue",
        marginBottom: 10,
      }}
      key={id}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0px 10px",
        }}
      >
        <p
          style={{
            color: BLACK_COLOR,
            fontSize: 14,
          }}
        >
          Account {title}
        </p>
        <RiDeleteBinLine
          color="#FF2020"
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            onClickDelete(id);
          }}
        />
      </div>

      <div
        style={{
          ...inputStyle,
        }}
      >
        {accountNumber}
      </div>
      <div
        style={{
          ...inputStyle,
        }}
      >
        {ifscCode}
      </div>
    </div>
  );
};
function AddAccountModal({ onClose, accountFromRedux }) {
  const { width, height } = ResizeListener();

  // const [accountFromRedux, setAllAccounts] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIFSCCode] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    minWidth: 220,
    maxWidth: 450,
    marginRight: 20,
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        borderRadius: 30,
        width: "100%",
        height: "100%",
        alignItems: "center",
        maxHeight: height * 0.85,
        paddingBottom: 0,
      }}
    >
      <div>
        <p
          style={{
            color: BLACK_COLOR,
            fontWeight: "500",
            fontFamily: "Roboto",
          }}
        >
          Authorised Accounts
        </p>
      </div>

      <div
        style={{
          overflow: "auto",
          width: "100%",
        }}
      >
        {accountFromRedux?.map((data, index) => (
          <AccountContainer
            accountNumber={data.accountNumber}
            ifscCode={data.ifscCode}
            id={index}
            title={index + 1}
            onClickDelete={(id) => {
              dispatch(deleteOneAccountAction(id));
            }}
          />
        ))}
        <div
          style={{
            width: "100%",
            padding: "15px 10px",
            border: "1px solid dodgerblue",
            marginBottom: 30,
          }}
        >
          <CustomInput
            value={accountNumber}
            onChange={(data) => setAccountNumber(data)}
            inputStyles={{ ...inputStyle }}
            placeholder="Enter Account Number"
            type="input"
            validator="accountNumber"
          />
          <CustomInput
            value={ifscCode}
            onChange={(data) => setIFSCCode(data)}
            inputStyles={{ ...inputStyle }}
            placeholder="Enter IFSC code"
            type="input"
            validator="ifscCode"
          />
        </div>
      </div>

      <div>
        <div>
          <p
            style={{
              color: accountFromRedux.length < 10 ? "dodgerblue" : "grey",
              fontSize: 13,
              cursor: "pointer",
              fontWeight: "500",
            }}
            onClick={() => {
              if (
                accountFromRedux.length < 10 &&
                accountNumber !== "" &&
                ifscCode !== "" &&
                (accountNumber.length >= 9 || accountNumber.length <= 25) &&
                ifscCode.length === 11
              ) {
                dispatch(
                  addAccountsAction([
                    {
                      accountNumber,
                      ifscCode,
                    },
                  ])
                );
                setAccountNumber("");
                setIFSCCode("");
              } else {
                if (accountNumber.length < 9 || accountNumber.length > 25) {
                  enqueueSnackbar("Please enter the valid account number ", {
                    variant: "error",
                  });
                } else {
                  enqueueSnackbar("Please enter the valid ifsc code", {
                    variant: "error",
                  });
                }
              }
            }}
          >
            + Add Another Account{" "}
            <span style={{ color: "#888888", fontSize: 14 }}>
              {`(${10 - accountFromRedux.length} more accounts can be added)`}
            </span>
          </p>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          margin: "10px 0px 25px 0px",
        }}
      >
        <RowButtons
          onClick1={() => {
            onClose();
          }}
          onClick2={() => {
            if (
              accountNumber !== "" &&
              ifscCode !== "" &&
              accountNumber.length >= 9 &&
              accountNumber.length <= 25 &&
              ifscCode.length === 11
            ) {
              dispatch(
                addAccountsAction([
                  {
                    accountNumber,
                    ifscCode,
                  },
                ])
              );
              onClose();
            } else if (accountNumber === "" && ifscCode === "") {
              onClose();
            } else {
              if (accountNumber.length < 9 || accountNumber.length > 25) {
                enqueueSnackbar("Please enter the valid account number ", {
                  variant: "error",
                });
              } else {
                enqueueSnackbar("Please enter the valid ifsc code", {
                  variant: "error",
                });
              }
              // onClose();
            }

            // dispatch(addAccountsAction(accountFromRedux));
          }}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            minWidth: 260,
          }}
          buttonStyle1={{
            width: "48%",
            border: "1px solid dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          textStyles1={{
            color: "dodgerblue",
          }}
          buttonStyle2={{
            width: "48%",
            backgroundColor: "dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          buttonTitle2="Save"
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    accountFromRedux: state.addAccountsReducer.accounts,
  };
};

export default connect(mapStateToProps)(AddAccountModal);
